import { call, put, takeLatest } from "redux-saga/effects"
import { GET_LIST_DIMENSIONS_WATCHER } from "./constants"

import { getListDimensionsSuccess, getListDimensionsFailed } from "./actions"
import { getListDimensionsApi } from "../../../../../utils/routes/routes-report"

export function* getListDimensionsSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: listDimensions } = yield call(
      getListDimensionsApi,
      dataStatus.params
    )
    yield put(getListDimensionsSuccess(listDimensions))
  } catch (e) {
    yield put(getListDimensionsFailed())
  }
}

// Individual exports for testing
export default function* widgetListDimensionsSaga() {
  yield takeLatest(GET_LIST_DIMENSIONS_WATCHER, getListDimensionsSaga)
}
